module.exports = "<h3>404 Page Not Found</h3>\n<p>Sorry, there is nothing to see here...</p>"


//////////////////
// WEBPACK FOOTER
// C:/Users/markl/projects/angularapp/src/app/components/not-found/not-found.component.html
// module id = ../../../../../src/app/components/not-found/not-found.component.html
// module chunks = main